/* eslint-disable react/no-array-index-key */
import { Text, Flex, Box, Button, Link, Avatar, Tabs } from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { User } from '../models/User';
import LabelValueDisplayItem from './LabelValueDisplayItem';

type PageTabsProps = {
  tabNames: string[];
  selectedTab: string;
  handleTabSelected: (tab: string) => void;
};

export function PageTabs({ tabNames, selectedTab, handleTabSelected }: PageTabsProps) {
  return (
    <Flex flex={1} width="100%" fontWeight="bold">
      {tabNames.map((tab, i) => (
        <Flex
          key={i.toString()}
          flex={1}
          px={12}
          py={1}
          justifyContent="center"
          borderLeftRadius={i === 0 ? 'md' : undefined}
          borderRightRadius={i === tabNames.length - 1 ? 'md' : undefined}
          borderColor="orange.400"
          borderWidth={1}
          bg={selectedTab === tab ? 'orange.400' : 'white'}
          color={selectedTab === tab ? 'white' : 'orange.400'}
          onClick={() => handleTabSelected(tab)}
        >
          {tab}
        </Flex>
      ))}
    </Flex>
  );
}
